import './style.css'

import { graphql, useStaticQuery } from 'gatsby'
import * as R from 'ramda'
import React, { FunctionComponent } from 'react'

import { FlipCardRow, MenuItem } from './FipCard'

const MemoryMenuComponent: FunctionComponent<{ menuItems: MenuItem[] }> = ({
  menuItems,
}) => {
  const row1 = R.slice(0, 3)(menuItems)
  const row2 = R.slice(3, 6)(menuItems)
  const row3 = R.slice(6, 9)(menuItems)

  return (
    <div className="pt-5 d-none d-sm-block">
      <FlipCardRow menuItems={row1} />
      <FlipCardRow menuItems={row2} />
      <FlipCardRow menuItems={row3} />
    </div>
  )
}

export const query = graphql`
  query MenuQuery {
    menuJson {
      entries {
        name
        path
      }
    }
  }
`

export const MemoryMenu: FunctionComponent = () => {
  const {
    menuJson: { entries },
  } = useStaticQuery(query)

  return <MemoryMenuComponent menuItems={entries} />
}
